// Central place for every outbound link on the landing page.
// Swap RETAILER_DEMO_URL, CONTACT_URL and PRIVACY_URL when their real destinations exist.
export const LINKS = {
  APP_URL: "https://intuitiveshoes.app/",
  RETAILER_DEMO_URL: "https://intuitiveshoesdemo.com/product/lemon-and-lavender-womens-high-top-sneakers/",
  CONTACT_URL: "mailto:info@libraplanet.bg?subject=Intuitive%20Shoes%20%E2%80%94%20Retailer%20%2F%20Partnership%20Enquiry",
  PRIVACY_URL: "/privacy",
};

export const NAV_ITEMS = [
  { label: "How It Works", href: "#how-it-works" },
  { label: "For Shoppers", href: "#shoppers" },
  { label: "For Retailers", href: "#retailers" },
  { label: "Vision", href: "#vision" },
  { label: "Demo", href: "#demo" },
];
